const components = {
  MuiCssBaseline: {
    styleOverrides: (theme) => ({
      body: {
        fontFeatureSettings: "'ss01' on, 'ss02' on",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        colorScheme: theme.palette.mode,
        "--jy-surface-1": theme.palette.background.paper,
        "--jy-surface-2": theme.palette.mode === "dark" ? "#1f1f1f" : "#ffffff",
        "--jy-surface-muted": theme.palette.mode === "dark" ? "#1b1b1b" : "#f5f5f5",
        "--jy-surface-elevated": theme.palette.mode === "dark" ? "#242424" : "#ffffff",
        "--jy-border": theme.palette.divider,
        "--jy-text-primary": theme.palette.text.primary,
        "--jy-text-secondary": theme.palette.text.secondary,
        "--jy-card-shadow":
          theme.palette.mode === "dark"
            ? "0 12px 28px rgba(0, 0, 0, 0.45)"
            : "0 12px 28px rgba(50, 30, 60, 0.08)",
        "--jy-badge-bg": theme.palette.mode === "dark" ? "#2b2b2b" : "#ffe0b3",
        "--jy-badge-text": theme.palette.mode === "dark" ? theme.palette.text.secondary : "#b65c00",
        "--jy-page-gradient":
          theme.palette.mode === "dark"
            ? "radial-gradient(circle at top right, rgba(255, 140, 0, 0.18), transparent 55%), radial-gradient(circle at 20% 15%, rgba(4, 106, 56, 0.2), transparent 45%)"
            : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      },
    }),
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 600,
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 8,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        paddingTop: 10,
        paddingBottom: 10,
      },
      head: {
        fontWeight: 600,
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: "1px solid",
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        borderRadius: 10,
      },
    },
  },
};

export default components;
